import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CButton from '@/components/shared/CButton';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
    value: { type: Boolean },
    title: null,
    description: null,
    actionVerb: null,
    hideCancel: { type: Boolean }
  },
  emits: ["input", "ok", "cancel"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'ok'): void;
    (event: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
    title?: string;
    description?: string;
    actionVerb: string;
    hideCancel?: boolean;
};





const isOpen = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        emit('input', value);
    }
});

return { __sfc: true,emit, props, isOpen, CButton }
}

})